export default __webpack_public_path__ + "static/media/Google_Play_Icon.a9aec302.svg";